import { Component, Input, Output, EventEmitter, HostListener,  ElementRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { CfCoreGalleryHelperService } from './cf-core-gallery-helper.service';
export class CfCoreGalleryImageComponent implements OnInit, OnChanges {
     images: string[];
     clickable: boolean;
     selectedIndex: number;
     arrows: boolean;
     arrowsAutoHide: boolean;
     swipe: boolean;
     animation: string;
     size: string;

     onClick = new EventEmitter();
     onActiveChange = new EventEmitter();
/**
 * @param {?} elementRef
 * @param {?} helperService
 */
constructor(private elementRef: ElementRef,
private helperService: CfCoreGalleryHelperService) {}
/**
 * @return {?}
 */
ngOnInit(): void {
        if (this.arrows && this.arrowsAutoHide) {
            this.arrows = false;
        }
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        if (changes['images']) {
            this.selectedIndex = 0;
        }

        if (changes['swipe']) {
            this.helperService.manageSwipe(this.swipe, this.elementRef, 'image', () => this.showNext(), () => this.showPrev());
        }
    }
/**
 * @return {?}
 */
onMouseEnter() {
        if (this.arrowsAutoHide && !this.arrows) {
            this.arrows = true;
        }
    }
/**
 * @return {?}
 */
onMouseLeave() {
        if (this.arrowsAutoHide && this.arrows) {
            this.arrows = false;
        }
    }
/**
 * @param {?} event
 * @param {?} index
 * @return {?}
 */
handleClick(event: Event, index: number): void {
        if (this.clickable) {
            this.onClick.emit(index);

            event.stopPropagation();
            event.preventDefault();
        }
    }
/**
 * @return {?}
 */
showNext(): void {
        if (this.canShowNext()) {
            this.selectedIndex++;
            this.onActiveChange.emit(this.selectedIndex);
        }
    }
/**
 * @return {?}
 */
showPrev(): void {
        if (this.canShowPrev()) {
            this.selectedIndex--;
            this.onActiveChange.emit(this.selectedIndex);
        }
    }
/**
 * @return {?}
 */
canShowNext(): boolean {
        if (this.images) {
            return this.selectedIndex < this.images.length - 1 ? true : false;
        } else {
            return false;
        }
    }
/**
 * @return {?}
 */
canShowPrev(): boolean {
        if (this.images) {
            return this.selectedIndex > 0 ? true : false;
        } else {
            return false;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'cf-core-gallery-image',
    template: "<div class=\"cf-core-gallery-image-wrapper cf-core-gallery-animation-{{animation}} cf-core-gallery-image-size-{{size}}\"> <div class=\"cf-core-gallery-image\" *ngFor=\"let image of images; let i = index\" [ngClass]=\"{ 'cf-core-gallery-active': selectedIndex == i, 'cf-core-gallery-inactive-left': selectedIndex > i, 'cf-core-gallery-inactive-right': selectedIndex < i, 'cf-core-gallery-clickable': clickable }\" [style.background-image]=\"'url(' + image + ')'\" (click)=\"handleClick($event, i)\"></div> </div> <cf-core-gallery-arrows class=\"cf-core-gallery-image-size-{{size}}\" *ngIf=\"arrows\" (onPrevClick)=\"showPrev()\" (onNextClick)=\"showNext()\" [prevDisabled]=\"!canShowPrev()\" [nextDisabled]=\"!canShowNext()\" ></cf-core-gallery-arrows> ",
    styles: [":host { width: 100%; display: inline-block; position: relative; } .cf-core-gallery-image-wrapper { width: 100%; height: 100%; position: absolute; left: 0px; top: 0px; overflow: hidden; } .cf-core-gallery-image { background-position: center; background-repeat: no-repeat; height: 100%; width: 100%; position: absolute; top: 0px; } .cf-core-gallery-image.cf-core-gallery-active { z-index: 1000; } .cf-core-gallery-image-size-cover .cf-core-gallery-image { background-size: cover; } .cf-core-gallery-image-size-contain .cf-core-gallery-image { background-size: contain; } .cf-core-gallery-animation-fade .cf-core-gallery-image { left: 0px; opacity: 0; transition: 0.5s ease-in-out; } .cf-core-gallery-animation-fade .cf-core-gallery-image.cf-core-gallery-active { opacity: 1; } .cf-core-gallery-animation-slide .cf-core-gallery-image { transition: 0.5s ease-in-out; } .cf-core-gallery-animation-slide .cf-core-gallery-image.cf-core-gallery-active { left: 0px; } .cf-core-gallery-animation-slide .cf-core-gallery-image.cf-core-gallery-inactive-left { left: -100%; } .cf-core-gallery-animation-slide .cf-core-gallery-image.cf-core-gallery-inactive-right { left: 100%; } .cf-core-gallery-animation-rotate .cf-core-gallery-image { transition: 1s ease; transform: scale(3.5, 3.5) rotate(90deg); left: 0px; opacity: 0; } .cf-core-gallery-animation-rotate .cf-core-gallery-image.cf-core-gallery-active { transform: scale(1, 1) rotate(0deg); opacity: 1; } .cf-core-gallery-animation-zoom .cf-core-gallery-image { transition: 1s ease; transform: scale(2.5, 2.5); left: 0px; opacity: 0; } .cf-core-gallery-animation-zoom .cf-core-gallery-image.cf-core-gallery-active { transform: scale(1, 1); opacity: 1; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: CfCoreGalleryHelperService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'images': [{ type: Input },],
'clickable': [{ type: Input },],
'selectedIndex': [{ type: Input },],
'arrows': [{ type: Input },],
'arrowsAutoHide': [{ type: Input },],
'swipe': [{ type: Input },],
'animation': [{ type: Input },],
'size': [{ type: Input },],
'onClick': [{ type: Output },],
'onActiveChange': [{ type: Output },],
'onMouseEnter': [{ type: HostListener, args: ['mouseenter', ] },],
'onMouseLeave': [{ type: HostListener, args: ['mouseleave', ] },],
};
}

function CfCoreGalleryImageComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryImageComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreGalleryImageComponent.ctorParameters;
/** @type {?} */
CfCoreGalleryImageComponent.propDecorators;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.images;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.clickable;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.selectedIndex;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.arrows;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.arrowsAutoHide;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.swipe;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.animation;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.size;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.onClick;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.onActiveChange;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.elementRef;
/** @type {?} */
CfCoreGalleryImageComponent.prototype.helperService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
